var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMutation, useQueryClient } from 'react-query';
import { useAxios } from 'shared/hooks';
import { useToast, ToastSuccessBox } from 'shared/components';
import { formatFullDate } from 'shared/utils';
import { queryCache } from '../../../reactQuery';
export var useHideAppointment = function (_a) {
    var memberId = _a.memberId, onError = _a.onError, onSuccess = _a.onSuccess;
    var queryClient = useQueryClient();
    var axios = useAxios();
    var toast = useToast();
    return useMutation(function (_a) {
        var appointment = _a.appointment, payload = __rest(_a, ["appointment"]);
        return axios.request({
            method: 'POST',
            data: payload,
            url: "/api/v1/appointments/".concat(appointment.id, "/hide"),
        });
    }, {
        onError: onError,
        onSuccess: function (_, _a) {
            var appointment = _a.appointment;
            queryCache.removeQueries(['past_interactions', memberId]);
            queryClient.invalidateQueries(['past_interactions', memberId]);
            queryClient.invalidateQueries('todo_notes');
            queryClient.invalidateQueries('upcoming_appts');
            toast({
                status: 'success',
                position: 'top',
                duration: 3000,
                isClosable: true,
                render: function (_a) {
                    var onClose = _a.onClose;
                    return (_jsx(ToastSuccessBox, { onClose: onClose, title: "Note for ".concat(formatFullDate(appointment.start_at, true, true), " deleted successfully!"), variant: "success", progressDuration: 3000 }));
                },
            });
            onSuccess && onSuccess();
        },
    });
};
